import { MDSTextVariant } from "@/mds/components/text";

export interface MDSPlanCardProps {
  plan: MDSPlanId;
  children?: React.ReactNode;
  features: string[];
  background: MDSPlanCardBackground;
  border?: MDSPlanCardBorder;
  priceVariant?: MDSTextVariant;
  priceTermVariant?: MDSTextVariant;
}

export enum MDSPlanCardBackground {
  None = "none",
  Default = "default",
  Emphasis = "emphasis",
}

export enum MDSPlanCardBorder {
  None = "none",
  Default = "default",
  Emphasis = "emphasis",
}

export enum MDSPlanId {
  Free = "free",
  Paid = "paid",
}

export enum MDSPlanCardSlot {
  Title = "title",
  Price = "price",
  PriceTerm = "priceTerm",
  TitleBadge = "titleBadge",
  Footer = "footer",
}
